import React from 'react'
import Tabs from '@material-ui/core/Tabs'
import styles from './styles'
import { withStyles } from '@material-ui/core'

export default withStyles(styles)(Tabs)
